import { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { AuthCard } from "@/components/AuthCard";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { const { data } = await api.post("/auth/forgot-password", { email }); setSent(data.message); }
    catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <AuthCard eyebrow="Password help" title="Forgotten your password?" testId="forgot-page">
      {sent ? (
        <div className="rounded-xl bg-leaf/10 border border-leaf/30 p-5 text-sm flex gap-3" data-testid="forgot-sent">
          <MailCheck className="h-5 w-5 text-leaf shrink-0" /><p>{sent} Check your spam folder if it hasn't arrived in a few minutes.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <p className="text-muted-foreground">Enter the email you signed up with and we'll send you a link to choose a new password.</p>
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@yourbusiness.co.uk" data-testid="forgot-email-input" className="h-11 bg-white" />
          {error && <p className="text-sm text-rose-600" data-testid="forgot-error">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="forgot-submit-btn" className="w-full h-11 rounded-full bg-navy hover:bg-navy/90 text-white">
            {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Send reset link
          </Button>
        </form>
      )}
    </AuthCard>
  );
}
